/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estado inicial de entidad legal
 */
export const INITIAL_LEGAL_ENTITY_STATE = {
  uuid: null,
  legal_business_name: '',
  company: '',
  cuit: '',
  libb: '',
  address: '',
  postal_code: '',
  phone_number: '',
  email: '',
  uuid_country: '',
  uuid_province: '',
  uuid_department: '',
  uuid_district: '',
  is_intermediate_entity: '0',
  contact_information: '',
  membership_fee: '',
  observations: '',
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Persona Jurídica creada exitosamente',
    UPDATE: 'Persona Jurídica actualizada exitosamente',
    DELETE: 'Persona Jurídica eliminada exitosamente',
  },
  ERROR: {
    CREATE: 'Error al crear la Persona Jurídica',
    UPDATE: 'Error al actualizar la Persona Jurídica',
    DELETE: 'Error al eliminar la Persona Jurídica',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_CUIT: 'CUIT inválido',
    INVALID_EMAIL: 'Email inválido',
    INVALID_PHONE: 'Teléfono inválido',
  },
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  company: { width: '15%' },
  cuit: { width: '10%' },
  legalBusinessName: { width: '15%' },
  intermediateEntity: { width: '5%' },
  membershipFee: { width: '5%' },
  contactInfo: { width: '10%' },
  actions: { width: '15%' },
};
